import React from 'react'
import { NavLink } from 'react-router-dom'
import TextFeild from './TextFeild'

const VerificationModal = () => {
    return (
        <div className='h-screen flex items-center justify-center '>
            <section class="rounded-3xl shadow-2xl">
                <div class="p-8 text-center sm:p-12">
                    <p class="text-sm font-semibold uppercase tracking-widest text-slate-500">
                        Enter verification Code
                    </p>

                    <h2 class="mt-6 text-2xl font-bold">
                        Please enter verification code sent to your number
                    </h2>
                    <TextFeild />


                   <NavLink to={'/completed'}>
                   <a
                        class="mt-8 inline-block w-full rounded-full bg-slate-600 hover:bg-slate-500 py-4 text-sm font-bold text-white shadow-xl"
                        href="#/"
                    >
                        Submit
                    </a>
                   </NavLink>
                </div>
            </section>

        </div>
    )
}

export default VerificationModal